<template>
	<div class="home-page" :class="{ 'menu-open': menuOpen }">
		<!-- 顶部导航 - 不显示 logo -->
		<Header 
			:showLogo="false" 
			:theme="'dark'" 
			:fixed="true" 
			:showBorder="false" 
			:backgroundColor="'transparent'" 
			@menu-open="menuOpen = true" 
			@menu-close="menuOpen = false" 
			:iconColor="'white'" 
		/>

		<!-- Hero Section -->
		<section class="hero-section" :style="{ backgroundImage: `url(${topBannerImage})` }">
			<!-- 文字居中 -->
			<div class="hero-center">
				<h2 class="hero-subtitle font-apercu-medium" style="cursor: pointer;">Coming Soon...</h2>
			</div>
			<!-- 底部 logo -->
			<div class="hero-bottom">
				<div class="hero-logo-wrapper"  @click="goHome" style="cursor: pointer;">
					<img :src="logoWhite" alt="denHolm" class="hero-logo" />
				</div>
			</div>
		</section>
	</div>
</template>

<script>
	import Header from '../components/Header.vue'
	import logoWhite from '../assets/logo_w.png'

	export default {
		name: 'Home',
		components: {
			Header
		},
		data() {
			return {
				menuOpen: false,
				topBannerImage: require('../assets/materials_bg.jpg'),
				logoWhite,
			}
		},
		methods: {
			openMenu() {
				this.menuOpen = true
			},
			// 点击 Logo 返回首页
			goHome() {
			  this.$router.push('/')
			}
		}
	}
</script>

<style scoped>
	/* ===== 页面容器 ===== */
	.home-page {
		width: 100%;
		height: 100vh;
		overflow: hidden;
		position: relative;
		background: #000;
	}

	/* ===== Hero 区域 ===== */
	.hero-section {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		width: 100vw;
		height: 100vh;
		background-repeat: no-repeat;
		background-size: cover;
		background-position: center;
		display: flex;
		flex-direction: column;
		justify-content: center;  /* 让 .hero-center 垂直居中 */
		align-items: center;
		z-index: 0;
		padding: 0 31rem;  /* 左右间距统一 */
		box-sizing: border-box;
	}

	/* ===== 文字居中 ===== */
	.hero-center {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		flex: 1;  /* 占据剩余空间，使文字居中 */
		width: 100%;
		text-align: center;
		color: #fff;
		z-index: 1;
	}

	.hero-subtitle {
		font-size: 24rem;
		font-weight: 500;
		margin: 0;
	}

	/* ===== 底部 logo ===== */
	.hero-bottom {
		width: 100%;
		display: flex;
		justify-content: center;
		padding-bottom: 61rem;  /* 底部间距，与设计稿一致 */
		box-sizing: border-box;
		z-index: 1;
	}

	.hero-logo-wrapper {
		width: 100%;
		max-width: 100%;
		display: flex;
		justify-content: center;
	}

	.hero-logo {
		width: 100%;
		max-width: 100%;
		height: auto;
		display: block;
	}

	/* ===== 响应式 ===== */
	@media (max-width: 768px) {
		.hero-subtitle {
			font-size: 20rem;
		}
		.hero-bottom {
			padding-bottom: 40rem;
		}
	}

	@media (max-width: 480px) {
		.hero-subtitle {
			font-size: 16rem;
		}
		.hero-bottom {
			padding-bottom: 30rem;
		}
	}
</style>